import React from 'react';
import Link from 'react-router';
import Moment from 'react-moment';

import { Meteor } from 'meteor/meteor';

import {
  Button
} from '@sketchpixy/rubix';

export default class FlightListComponent extends React.Component {

  	render() {
  		if(this.props.flight.deleted == true) {
  			return <span></span>;
  		}

  	  	return (
  	  	  	<tr>
              <td>{this.props.flight.title}</td>
              <td>Oui</td>
              <td><Moment format="DD/MM/YYYY">{this.props.flight.createdAt}</Moment></td>
              <td><Moment format="DD/MM/YYYY">{this.props.flight.editedAt}</Moment></td>
              <td>
                  <Button bsStyle="warning" onClick={this.goToEditView.bind(this)}>Modifier</Button>&nbsp;&nbsp;
                  <Button bsStyle="danger" onClick={this.deleteThisPrice.bind(this)}>Supprimer</Button>
              </td>
            </tr>
  	  	);
  	}

    deleteThisPrice() {
      Meteor.call('flightsType.remove', this.props.flight._id);
    }

    goToEditView() {
     this.context.router.push('/flights/' + this.props.flight._id);
    }

}

FlightListComponent.propTypes = {
  // This component gets the task to display through a React prop.
  // We can use propTypes to indicate it is required
  flight: React.PropTypes.object.isRequired,
};

FlightListComponent.contextTypes = {
  router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/flights-type/component-flights-type-list.js
 **/